export default '/static/frontend/ReachDigital/12gobiking/dist/assets/americanexpress2-e46eb39e.svg'